export enum UserPlanStatusEnum {
  ACTIVE          = 1,
  PAUSED_CANCELED = 2,
}
